import * as React from 'react';
import { connect } from 'react-redux';


// TODO: Find a better way. Context, maybe?
const CurrentOrgInjector = (props) => {
  const { auth, component, ...rest } = props;

  if (!auth.currentUser) {
    // TODO: Loading indicator?
    return (
      <div />
    );
  }

  const Component = component;

  return (
    <Component
      orgId={auth.currentUser.organizationId}
      {...rest}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.shared.auth,
  };
};

export default connect(mapStateToProps)(CurrentOrgInjector) as any;
